/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationCancellation200Response
 */
export interface GetReservationCancellation200Response {
    /**
     * 
     * @type {string}
     * @memberof GetReservationCancellation200Response
     */
    unit: GetReservationCancellation200ResponseUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof GetReservationCancellation200Response
     */
    time: number;
}


/**
 * @export
 */
export const GetReservationCancellation200ResponseUnitEnum = {
    Minutes: 'minutes',
    Hours: 'hours',
    Days: 'days'
} as const;
export type GetReservationCancellation200ResponseUnitEnum = typeof GetReservationCancellation200ResponseUnitEnum[keyof typeof GetReservationCancellation200ResponseUnitEnum];


/**
 * Check if a given object implements the GetReservationCancellation200Response interface.
 */
export function instanceOfGetReservationCancellation200Response(value: object): value is GetReservationCancellation200Response {
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    return true;
}

export function GetReservationCancellation200ResponseFromJSON(json: any): GetReservationCancellation200Response {
    return GetReservationCancellation200ResponseFromJSONTyped(json, false);
}

export function GetReservationCancellation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationCancellation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'unit': json['unit'],
        'time': json['time'],
    };
}

export function GetReservationCancellation200ResponseToJSON(json: any): GetReservationCancellation200Response {
    return GetReservationCancellation200ResponseToJSONTyped(json, false);
}

export function GetReservationCancellation200ResponseToJSONTyped(value?: GetReservationCancellation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'unit': value['unit'],
        'time': value['time'],
    };
}

